// extracted by mini-css-extract-plugin
export default {"priceItem":"Overview-priceItem_AbuiK","svg":"Overview-svg_I7wJm"};